"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionStatusType = void 0;
exports.SubscriptionStatusType = {
    Trialing: "trialing",
    Active: "active",
    Incomplete: "incomplete",
    PastDue: "past_due",
    Free: "free",
    FreeDisabled: "free_disabled",
};
